import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';
import logo from '../asset/logo/logo.png';
const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#eecda3] border-t-2 to-[#6dd5ed] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div className="space-y-4 flex flex-col items-center">
            <h3 className="text-2xl font-bold mb-4 text-blue-400">Contact Us</h3>
            <div className="flex flex-col items-left">
            <div className="flex items-center space-x-3">
              <FaPhone className="text-blue-400" />
              <p className="text-black">+91 8053232672</p>
            </div>
            <div className="flex items-center space-x-3">
              <FaEnvelope className="text-blue-400" />
              <a 
                    href="mailto:director@valarccifoundation.co.in" 
                    className="text-blue-800 hover:text-blue-400 transition-colors"
                  >
                    director@valarccifoundation.co.in
                  </a>
            </div>
            <div className="flex items-center space-x-3">
              <FaMapMarkerAlt className="text-blue-400" />
              <p className="text-black">Vpo. Bandaheri, Hisar, Haryana 125001</p>
            </div>
            <div className="flex items-center space-x-3">
              <FaGlobe className="text-blue-400" />
              <p className="text-black">valarccifoundation.co.in</p>
            </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold mb-4 text-blue-400">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-blue-400 text-black transition-colors">Home</a></li>
              <li><a href="/about" className="hover:text-blue-400 text-black transition-colors">About Us</a></li>
              <li><a href="/events" className="hover:text-blue-400 text-black transition-colors">Events</a></li>
              <li><a href="/contact" className="hover:text-blue-400 text-black transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold mb-4 text-blue-400">Follow Us</h3>
            <div className="flex items-center justify-center space-x-4">
              <a 
                href="https://www.instagram.com/valarcci_foundation" 
                className="text-2xl hover:text-blue-400 transition-colors text-black hover:scale-110 transform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
              <a 
                href="https://www.instagram.com/valarcci_foundation" 
                className="text-2xl hover:text-blue-400 transition-colors text-black hover:scale-110 transform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </a>
              <a 
                href="https://www.instagram.com/valarcci_foundation" 
                className="text-2xl hover:text-blue-400 transition-colors text-black hover:scale-110 transform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.instagram.com/valarcci_foundation" 
                className="text-2xl hover:text-blue-400 transition-colors text-black hover:scale-110 transform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
            </div>
            <div className="flex items-center justify-center space-x-4">
              <img src={logo} alt="logo" className="w-24 h-24" />
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-black">
            © {new Date().getFullYear()} VALARCCI FOUNDATION. All rights reserved.
          </p>
          <p className="text-black mt-2">
            CIN: U85100HR2021NPL097932
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 